<template>
<e-chart ref="chart" />
</template>

<script>
import {AXIS_LABEL, AXIS_LINE_STYLE, NUMBER_FONT_FAMILY} from './FactorCharts/chartStyle'
export default {
  name: 'AQILevelDaysChart',
  props: {
    data: {
      required: true,
      type: Object
    }
  },
  methods: {
    render (isReal) {
      let {series, xAxisData, dataTime} = this.data

      let chartOpt = {
        // title: {
        //   text: title
        // },
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 10
        },
        legend: {
          data: dataTime,
          bottom: 10
        },
        tooltip: {
          trigger: 'axis',
          appendToBody: true
        },
        grid: [{
          top: 40,
          right: 40,
          bottom: 45,
          left: 30,
          containLabel: true
        }],
        xAxis: {
          type: 'category',
          data: xAxisData
        },
        yAxis: {
          type: 'value',
          nameGap: 30,
          nameLocation: 'center',
          axisLine: {
            show: true,
            lineStyle: AXIS_LINE_STYLE
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            ...AXIS_LABEL,
            fontFamily: NUMBER_FONT_FAMILY
          }
        },
        color: ['#F6DA40', '#FF8772', '#fac858', '#FC5474', '#73c0de', '#BD97EB', '#00C2DF', '#9a60b4', '#ea7ccc'],
        series: series
      }

      this.$refs.chart.setOpt(chartOpt)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Data/AQILevelDaysChart.vue